import { GearInstance, StepperStep, StoreAddress } from 'types';
import { getCommonFormProps } from './commonData';
import { getSolidPriceErrorMessage } from 'utils/validators';
import { COUNTRY_SELECT, CURRENCY_SELECT } from '../../../consts';

export const getRentPricingStep = (
  instance: GearInstance,
  onPass: (data: any, toDraft?: boolean) => void,
  stores: StoreAddress[],
): StepperStep => ({
  stepName: 'Pricing & Location',
  onPass: async (data: any) => {
    onPass(data);
  },
  formProps: {
    buttonCaption: 'Next',
    ...getCommonFormProps(onPass),
    fields: [
      {
        type: 'secondTitle',
        fieldName: 'step_title',
        value: 'Pricing and Location',
      },
      {
        type: 'number',
        fieldName: 'price',
        placeholder: `Daily Price (${instance.currency})`,
        isThin: true,
        value: instance.price ? instance.price : undefined,
        prefix: '$',
        from: 1,
        to: 999999,
        required: true,
        validator: getSolidPriceErrorMessage,
      },
      {
        type: 'number',
        fieldName: 'deposit',
        placeholder: `Deposit (${instance.currency})`,
        isThin: true,
        value: instance.deposit,
        prefix: '$',
        from: 1,
        to: 999999,
        required: true,
        validator: getSolidPriceErrorMessage,
      },
      {
        type: 'hourRentBlock',
        value: instance,
      },
      instance.account_type==='business'
        ? {
          type: 'stores',
          fieldName: 'store_id',
          value: instance.store_id,
          stores,
        }
        : {
          type: 'meeting',
          value: instance,
        },
    ],
  },
});
